import { ICountingValuesDataElements } from "@types"
import { NoDataFound } from "components"
import { useEffect, useState } from "react"
import Chart from "react-apexcharts"

export const OccupancyGraph = ({
 selectedDetectors,
 _selectedDeviceData,
 checkboxValues,
 data,
}: {
 selectedDetectors: any
 _selectedDeviceData: any
 checkboxValues: any
 data: any
}) => {
 const [hasData, setHasData] = useState(false)

 const [chartState, setChartState] = useState({
  series: [] as { name: string; data: number[] }[],
  options: {
   chart: {
    height: 500,
    type: "area",
    id: "area-1",
    group: "social",
    zoom: {
     enabled: checkboxValues.counter === false,
    },
   },
   fill: {
    type: "gradient",
   },
   yaxis: {
    max: 100,
    min: 2,
   },

   stroke: {
    show: true,
    curve: "straight",
    lineCap: "round",
    width: 2,
   },
   dataLabels: {
    enabled: true,
   },
   legend: { show: true },
   xaxis: {
    type: "datetime",
    categories: [],
   },
   tooltip: {
    x: {
     format: "dd/MM/yy HH:mm",
    },
   },
  } as ApexCharts.ApexOptions,
 })

 useEffect(() => {
  if (data && _selectedDeviceData) {
   if (_selectedDeviceData.length > 0) {
    // updatedSeries are showing each detector name and its counter value
    const updatedSeries = _selectedDeviceData?.flatMap((selectedDeviceData: any) => {
     const detectorsData = selectedDeviceData.oepnv_data_elements?.flatMap(
      (element: ICountingValuesDataElements) => element.detector_list,
     )

     const newData = selectedDetectors?.map((detectorName: any) => {
      const _eachDetectorData = detectorsData
       .filter((detector: any) => detector.detector_name === detectorName)
       ?.map((detector: any) => Number(detector.occupancy_values))
      return {
       name: detectorName,
       data: _eachDetectorData || [],
      }
     })

     return newData
    })

    // updatedCategories are showing time interval
    const updatedCategories = _selectedDeviceData?.flatMap(
     (selectedDeviceData: any) =>
      selectedDeviceData.oepnv_data_elements?.map((intervalData: any) => intervalData?.interval[0]),
    )

    setChartState((prevChartState) => ({
     ...prevChartState,
     series: updatedSeries,
     options: {
      ...prevChartState.options,
      xaxis: {
       ...prevChartState?.options?.xaxis,
       categories: updatedCategories || [],
      },
     },
    }))

    setHasData(true)
   } else {
    setChartState((prevChartState) => ({
     ...prevChartState,
     series: [],
    }))

    setHasData(false)
   }
  }
 }, [data, selectedDetectors, _selectedDeviceData])

 useEffect(() => {
  setChartState((prevChartState) => ({
   ...prevChartState,
   options: {
    ...prevChartState.options,
    chart: { ...prevChartState.options.chart, zoom: { enabled: checkboxValues.counter === false } },
   },
  }))
 }, [checkboxValues])

 return (
  <div className="mt-6 w-[93%] ">
   <div className="flex">
    {hasData ? (
     <>
      <div className="w-[95%]" id="area-1">
       <Chart options={chartState?.options} series={chartState?.series} type="area" height={350} />
      </div>
      <div id="html-dist"></div>
     </>
    ) : (
     <NoDataFound />
    )}
   </div>
  </div>
 )
}
